import {
  API_BASE_URL,
  GET_ALL_AUD_VID_URL,
  GET_ALL_ARTISTS_URL,
  GET_ALL_GENRES_URL,
  GET_ALL_DIRECTORS_URL,
  GET_ALL_PLAYLISTS_URL,
  AUD_VID_ADD_NEW_URL,
  AUD_VID_UPDATE_URL,
  AUD_VID_DELETE_URL,
  ADD_PLAYLIST_URL,
  DELETE_PLAYLIST_URL,
  UPDATE_PLAYLIST_URL,
  GET_PLAYLISTS_ITEMS_URL,
  GET_ALL_CAST_URL,
  GET_ALL_SERIES_URL,
  ADD_SERIES_URL,
  UPDATE_SERIES_URL,
  DELETE_SERIES_URL,
  GET_SERIES_GENRES_URL,
  GET_SERIES_DIRECTORS_URL,
  GET_SERIES_CAST_URL,
  GET_SERIES_PLAYLISTS_URL,
  GET_ALL_SERIES_SEASONS_URL,
  ADD_SERIES_SEASON_URL,
  UPDATE_SERIES_SEASON_URL,
  DELETE_SERIES_SEASON_URL,
  ADD_SEASONS_EPISODE_URL,
  UPDATE_SEASONS_EPISODE_URL,
  DELETE_SEASONS_EPISODE_URL,
  GET_ALL_PODCASTS_URL,
  ADD_PODCAST_URL,
  UPDATE_PODCAST_URL,
  DELETE_PODCAST_URL,
  GET_PODCASTS_DIRECTORS_URL,
  GET_PODCASTS_TOPICS_URL,
  GET_PODCASTS_PLAYLISTS_URL,
  GET_PODCASTS_EPISODES_URL,
  ADD_PODCAST_EPISODE_URL,
  DELETE_PODCAST_EPISODE_URL,
  UPDATE_PODCAST_EPISODE_URL,
  ADD_MEDIA_FILE_ID_URL,
  GET_STREAMER_MEDIA_URL,
  DELETE_STREAMER_MEDIA_URL
} from '../variables'

import {
  GET_AUD_VID_BY_TYPE,
  ADD_AUD_VID,
  DELETE_AUD_VID,
  UPDATE_AUD_VID,
  GET_ARTIST,
  GET_GENRES,
  GET_DIRECTORS,
  GET_PLAYLISTS,
  ADD_PLAYLIST,
  UPDATE_PLAYLIST,
  DELETE_PLAYLIST,
  GET_PLAYLIST_ITEMS,
  GET_CASTS,
  GET_SERIES,
  ADD_SERIES,
  UPDATE_SERIES,
  DELETE_SERIES,
  GET_SERIES_GENRES,
  GET_SERIES_CASTS,
  GET_SERIES_DIRECTORS,
  GET_SERIES_PLAYLISTS,
  GET_SERIES_SEASONS,
  ADD_SERIES_SEASONS,
  DELETE_SERIES_SEASONS,
  UPDATE_SERIES_SEASONS,
  ADD_SEASONS_EPISODES,
  DELETE_SEASONS_EPISODES,
  UPDATE_SEASONS_EPISODES,
  GET_PODCASTS,
  ADD_PODCASTS,
  DELETE_PODCASTS,
  UPDATE_PODCASTS,
  GET_PODCASTS_DIRECTORS,
  GET_PODCASTS_TOPICS,
  GET_PODCASTS_PLAYLISTS,
  GET_PODCASTS_EPISODES,
  ADD_PODCASTS_EPISODES,
  DELETE_PODCASTS_EPISODES,
  UPDATE_PODCASTS_EPISODES,
  ADD_MEDIA_FILE_ID,
  GET_STREAMER_MEDIA,
  DELETE_STREAMER_MEDIA
} from '../actions/audvisual'

import axios from 'axios'

const state = {};
const mutations = {};
const getters = {};

const actions = {
  [GET_AUD_VID_BY_TYPE]: ({ commit, getters }, payload) => {
    return axios({
      method: 'get',
      url: API_BASE_URL + GET_ALL_AUD_VID_URL + payload.type,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }

    })
  },
  [ADD_AUD_VID]: ({ commit, getters }, payload) => {
    return axios({
      method: 'post',
      url: API_BASE_URL + AUD_VID_ADD_NEW_URL,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [DELETE_AUD_VID]: ({ commit, getters }, payload) => {
    return axios({
      method: 'delete',
      url: API_BASE_URL + AUD_VID_DELETE_URL + payload.id,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [UPDATE_AUD_VID]: ({ commit, getters }, payload) => {
    return axios({
      method: 'put',
      url: API_BASE_URL + AUD_VID_UPDATE_URL + payload.id,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [GET_ARTIST]: ({ commit, getters }, payload) => {
    return axios({
      method: 'post',
      url: API_BASE_URL + GET_ALL_ARTISTS_URL,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [GET_GENRES]: ({ commit, getters }, payload) => {
    return axios({
      method: 'post',
      url: API_BASE_URL + GET_ALL_GENRES_URL,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [GET_DIRECTORS]: ({ commit, getters }, payload) => {
    return axios({
      method: 'post',
      url: API_BASE_URL + GET_ALL_DIRECTORS_URL,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [GET_PLAYLISTS]: ({ commit, getters }, payload) => {
    return axios({
      method: 'post',
      url: API_BASE_URL + GET_ALL_PLAYLISTS_URL,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [ADD_PLAYLIST]: ({ commit, getters }, payload) => {
    return axios({
      method: 'post',
      url: API_BASE_URL + ADD_PLAYLIST_URL,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [UPDATE_PLAYLIST]: ({ commit, getters }, payload) => {
    return axios({
      method: 'put',
      url: API_BASE_URL + UPDATE_PLAYLIST_URL + payload.id,
      data: payload.data,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [DELETE_PLAYLIST]: ({ commit, getters }, payload) => {
    return axios({
      method: 'delete',
      url: API_BASE_URL + DELETE_PLAYLIST_URL + payload.id,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [GET_PLAYLIST_ITEMS]: ({ commit, getters }, payload) => {
    return axios({
      method: 'get',
      url: API_BASE_URL + GET_PLAYLISTS_ITEMS_URL + payload.id,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [GET_CASTS]: ({ commit, getters }, payload) => {
    return axios({
      method: 'post',
      url: API_BASE_URL + GET_ALL_CAST_URL,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [GET_SERIES]: ({ commit, getters }, payload) => {
    return axios({
      method: 'get',
      url: API_BASE_URL + GET_ALL_SERIES_URL,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [ADD_SERIES]: ({ commit, getters }, payload) => {
    return axios({
      method: 'post',
      url: API_BASE_URL + ADD_SERIES_URL,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [UPDATE_SERIES]: ({ commit, getters }, payload) => {
    return axios({
      method: 'put',
      url: API_BASE_URL + UPDATE_SERIES_URL + payload.id,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [DELETE_SERIES]: ({ commit, getters }, payload) => {
    return axios({
      method: 'delete',
      url: API_BASE_URL + DELETE_SERIES_URL + payload.id,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [GET_SERIES_GENRES]: ({ commit, getters }, payload) => {
    return axios({
      method: 'post',
      url: API_BASE_URL + GET_SERIES_GENRES_URL,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [GET_SERIES_CASTS]: ({ commit, getters }, payload) => {
    return axios({
      method: 'post',
      url: API_BASE_URL + GET_SERIES_CAST_URL,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [GET_SERIES_DIRECTORS]: ({ commit, getters }, payload) => {
    return axios({
      method: 'post',
      url: API_BASE_URL + GET_SERIES_DIRECTORS_URL,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [GET_SERIES_PLAYLISTS]: ({ commit, getters }, payload) => {
    return axios({
      method: 'post',
      url: API_BASE_URL + GET_SERIES_PLAYLISTS_URL,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [GET_SERIES_SEASONS]: ({ commit, getters }, payload) => {
    return axios({
      method: 'get',
      url: API_BASE_URL + GET_ALL_SERIES_SEASONS_URL + payload.id,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [ADD_SERIES_SEASONS]: ({ commit, getters }, payload) => {
    return axios({
      method: 'post',
      url: API_BASE_URL + ADD_SERIES_SEASON_URL + payload.serie_id,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [UPDATE_SERIES_SEASONS]: ({ commit, getters }, payload) => {
    return axios({
      method: 'put',
      url: API_BASE_URL + UPDATE_SERIES_SEASON_URL + payload.serie_id,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [DELETE_SERIES_SEASONS]: ({ commit, getters }, payload) => {
    return axios({
      method: 'delete',
      url: API_BASE_URL + DELETE_SERIES_SEASON_URL + payload.id,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [ADD_SEASONS_EPISODES]: ({ commit, getters }, payload) => {
    return axios({
      method: 'post',
      url: API_BASE_URL + ADD_SEASONS_EPISODE_URL,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [DELETE_SEASONS_EPISODES]: ({ commit, getters }, payload) => {
    return axios({
      method: 'delete',
      url: API_BASE_URL + DELETE_SEASONS_EPISODE_URL + payload.id,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [UPDATE_SEASONS_EPISODES]: ({ commit, getters }, payload) => {
    return axios({
      method: 'put',
      url: API_BASE_URL + UPDATE_SEASONS_EPISODE_URL + payload.id,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [GET_PODCASTS]: ({ commit, getters }, payload) => {
    return axios({
      method: 'get',
      url: API_BASE_URL + GET_ALL_PODCASTS_URL,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [ADD_PODCASTS]: ({ commit, getters }, payload) => {
    return axios({
      method: 'post',
      url: API_BASE_URL + ADD_PODCAST_URL,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [UPDATE_PODCASTS]: ({ commit, getters }, payload) => {
    return axios({
      method: 'put',
      url: API_BASE_URL + UPDATE_PODCAST_URL + payload.id,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [DELETE_PODCASTS]: ({ commit, getters }, payload) => {
    return axios({
      method: 'delete',
      url: API_BASE_URL + DELETE_PODCAST_URL + payload.id,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [GET_PODCASTS_DIRECTORS]: ({ commit, getters }, payload) => {
    return axios({
      method: 'post',
      url: API_BASE_URL + GET_PODCASTS_DIRECTORS_URL,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [GET_PODCASTS_TOPICS]: ({ commit, getters }, payload) => {
    return axios({
      method: 'post',
      url: API_BASE_URL + GET_PODCASTS_TOPICS_URL,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [GET_PODCASTS_PLAYLISTS]: ({ commit, getters }, payload) => {
    return axios({
      method: 'post',
      url: API_BASE_URL + GET_PODCASTS_PLAYLISTS_URL,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [GET_PODCASTS_EPISODES]: ({ commit, getters }, payload) => {
    return axios({
      method: 'get',
      url: API_BASE_URL + GET_PODCASTS_EPISODES_URL + payload.id,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [ADD_PODCASTS_EPISODES]: ({ commit, getters }, payload) => {
    return axios({
      method: 'post',
      url: API_BASE_URL + ADD_PODCAST_EPISODE_URL,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [DELETE_PODCASTS_EPISODES]: ({ commit, getters }, payload) => {
    return axios({
      method: 'delete',
      url: API_BASE_URL + DELETE_PODCAST_EPISODE_URL + payload.id,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [UPDATE_PODCASTS_EPISODES]: ({ commit, getters }, payload) => {
    return axios({
      method: 'put',
      url: API_BASE_URL + UPDATE_PODCAST_EPISODE_URL + payload.id,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [ADD_MEDIA_FILE_ID]: ({ commit, getters }, payload) => {
    return axios({
      method: 'post',
      url: API_BASE_URL + ADD_MEDIA_FILE_ID_URL,
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [GET_STREAMER_MEDIA]: ({ commit, getters }, payload) => {
    return axios({
      method: 'get',
      url: API_BASE_URL + GET_STREAMER_MEDIA_URL,
      params: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [DELETE_STREAMER_MEDIA]: ({ commit, getters }, payload) => {
    return axios({
      method: 'delete',
      url: API_BASE_URL + DELETE_STREAMER_MEDIA_URL + payload.id,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  }
};

export default {
  state,
  mutations,
  getters,
  actions
}
